export default __webpack_public_path__ + "media/images/react_icons/logo-white-9764c50f73219c5856ebfaa5778cfdea.svg";